import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, IconButton, List, ListItem, ListItemIcon, ListItemText, Modal, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { primaryButton } from "../../styles/commonStyles";
import { Link } from "react-router-dom";

const modalStyle = (theme) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 450,
  bgcolor: theme.palette.background.paper,
  boxShadow: theme.shadows[5],
  borderRadius: theme.shape.borderRadius,
  p: theme.spacing(4),
  border: `2px solid ${theme.palette.primary.main}`,
});

const TestingFeedbackModal = () => {
  const { t } = useTranslation("testing");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const hasVisited = localStorage.getItem("hasVisited");
    if (!hasVisited) {
      setOpen(true);
      localStorage.setItem("hasVisited", "true");
    }
  }, []);

  const handleClose = () => {
    setOpen(false);
    sessionStorage.setItem("modalDismissed", "true");
  };

  const handleSendFeedback = () => {
    window.location.href = "mailto:info@nutikorv.ee?subject=Tagasiside";
  };

  useEffect(() => {
    const lastVisit = localStorage.getItem("lastVisit");
    const now = new Date().getTime();
    const oneWeek = 7 * 24 * 60 * 60 * 1000; // One week in milliseconds
  
    if (!lastVisit || now - lastVisit > oneWeek) {
      setOpen(true);
      localStorage.setItem("lastVisit", now);
    }
  }, []);

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={modalStyle}>
        {/* Close Button */}
        <IconButton onClick={handleClose} sx={{ position: "absolute", top: 8, right: 8 }} aria-label={t("modal.close")}>
          <CloseIcon />
        </IconButton>

        {/* Modal Title */}
        <Typography variant="h6" sx={{ mb: 2, color: "primary.main", fontWeight: 600 }}>
          {t("modal.title")}
        </Typography>

        {/* Modal Description */}
        <Typography variant="body1" sx={{ mb: 2, color: "text.primary" }}>
          {t("modal.description")}
        </Typography>

        {/* Questions Section */}
        <Typography variant="body2" sx={{ fontWeight: "bold", color: "secondary.dark", mb: 1 }}>
          {t("modal.questions.q1")}
        </Typography>
        <List dense>
          <ListItem>
            <ListItemIcon>
              <CheckCircleIcon sx={{ color: "primary.dark" }} />
            </ListItemIcon>
            <ListItemText primary={t("modal.questions.q2")} />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CheckCircleIcon sx={{ color: "primary.dark" }} />
            </ListItemIcon>
            <ListItemText primary={t("modal.questions.q3")} />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CheckCircleIcon sx={{ color: "primary.dark" }} />
            </ListItemIcon>
            <ListItemText primary={t("modal.questions.q4")} />
          </ListItem>
        </List>

        {/* Important Notice */}
        <Typography
          variant="body2"
          sx={{
            fontWeight: "bold",
            mt: 2,
            p: 1.5,
            bgcolor: "warning.main",
            color: "warning.contrastText",
            borderRadius: "5px",
          }}
        >
          {t("modal.questions.q9")}
        
          <Link href="mailto:info@nutikorv.ee" sx={{ color: "inherit", fontWeight: "bold", textDecoration: "none" }}>
            📧 info@nutikorv.ee
          </Link>
        </Typography>

        {/* Thank You Message */}
        <Typography variant="body1" sx={{ mt: 2, fontStyle: "italic", color: "text.primary" }}>
          {t("modal.thanks")}
        </Typography>

        {/* Buttons Section */}
        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
          <Button onClick={handleSendFeedback} sx={primaryButton}>
            {t("modal.send_feedback")}
          </Button>
          <Button variant="outlined" onClick={handleClose} sx={{ borderColor: "primary.main", color: "primary.main" }}>
            {t("modal.dismiss")}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default TestingFeedbackModal;